import { z } from 'zod';
import { api } from './client';
import { itemSchema, messageSchema, userSchema, type User } from './schemas';

const loginSchema = itemSchema(
  z.looseObject({
    token: z.string(),
    token_type: z.string().optional(),
    expires_at: z.string().nullish(),
    user: userSchema,
  }),
);

export interface LoginInput {
  username: string;
  password: string;
}

export async function login(input: LoginInput): Promise<{ token: string; user: User }> {
  const { data } = await api.post('/auth/login', {
    username: input.username.trim().toLowerCase(),
    password: input.password,
  });
  const { token, user } = loginSchema.parse(data).data;
  return { token, user };
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout');
}

export async function me(): Promise<User> {
  const { data } = await api.get('/auth/me');
  return itemSchema(userSchema).parse(data).data;
}

export interface ChangePasswordInput {
  current_password: string;
  password: string;
}

const changePasswordSchema = messageSchema.extend({ data: userSchema });

export async function changePassword(input: ChangePasswordInput): Promise<User> {
  const { data } = await api.post('/auth/change-password', input);
  return changePasswordSchema.parse(data).data;
}
